import { Outlet } from "react-router";
import CommonHero from "../layout/common/commonHero";
import Navbar from "../layout/homePage/navbar/navbar";
import HowItWorksContent from "../layout/how-it-works/HowItWorksContent";
import HomePageFooter from "../layout/homePage/footer/HomePageFooter";

export default function HowItWorks() {
   return (
        <>
        <Navbar />
        <CommonHero />
        <Outlet />
        <HowItWorksContent />
        <HomePageFooter />
       </>
   );
}